import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import Footer from "./footer";
import Header from "./header";
import i18n from "./i18n";

import "../styles/bootstrap.min.css";
import "../styles/bootstrap.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../fonts/fonts.css";
import "../styles/custom.css";
import "../styles/responsive.css";
import "../styles/klaro.css";
import "../styles/header.css";
import "../styles/footer.css";

export default function Layout(props) {
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: i18n.language,
        }}
      >
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta http-equiv="X-UA-Compatible" content="IE=8,IE=9" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="p:domain_verify" content="f6e78fa6de7e3de0d04a28d675252268"/>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
      </Helmet>
      <Header
        current_page={props.pageInfo.key}
        current_item={props.pageInfo.item_key}
        current_lang={props.pageInfo.lang}
      />

      <div className="main-content">{props.children}</div>
      <Footer />
    </>
  );
}
